import React from "react";

/**
 * TipLingo wordmark — uses Plus Jakarta Sans 800 (bold modern sans) to match
 * the app-flow mockup exactly. The three accent icons are filled colored
 * circles with simple white symbols inside.
 */
export default function BrandMark({ size = "default", showIcons = true }) {
  const wordmark = size === "lg" ? "text-4xl" : "text-3xl";
  const icon = size === "lg" ? 30 : 26;
  return (
    <div className="flex items-center gap-2" data-testid="brand-mark">
      <h1
        className={`font-jakarta ${wordmark} font-extrabold tracking-tight leading-none`}
      >
        <span className="text-navy">Tip</span>
        <span className="text-orange">Lingo</span>
      </h1>
      {showIcons && (
        <div className="flex items-center gap-1 -mt-0.5">
          <GlobeIcon size={icon} />
          <CurrencyIcon size={icon} />
          <ForkIcon size={icon} />
        </div>
      )}
    </div>
  );
}

function GlobeIcon({ size = 26 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" aria-hidden>
      <circle cx="14" cy="14" r="14" fill="#2A6FD8" />
      <g fill="none" stroke="#fff" strokeWidth="1.4" strokeLinecap="round">
        <circle cx="14" cy="14" r="8" />
        <ellipse cx="14" cy="14" rx="3.5" ry="8" />
        <line x1="6" y1="14" x2="22" y2="14" />
        <line x1="14" y1="6" x2="14" y2="22" />
      </g>
    </svg>
  );
}

function CurrencyIcon({ size = 26 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" aria-hidden>
      <circle cx="14" cy="14" r="14" fill="#2E7D5A" />
      <text
        x="14"
        y="19"
        textAnchor="middle"
        fontSize="13"
        fontWeight="800"
        fill="#fff"
        fontFamily="Plus Jakarta Sans, sans-serif"
      >
        €|$
      </text>
    </svg>
  );
}

function ForkIcon({ size = 26 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" aria-hidden>
      <circle cx="14" cy="14" r="14" fill="#E55B2C" />
      {/* Fork - left */}
      <g fill="#fff">
        <rect x="7.2" y="6" width="1.6" height="6" rx="0.6" />
        <rect x="10" y="6" width="1.6" height="6" rx="0.6" />
        <rect x="12.8" y="6" width="1.6" height="6" rx="0.6" />
        <path d="M7 12 L14.6 12 L14.6 13.6 L11.6 13.6 L11.6 22 Q11.6 22.8 10.8 22.8 Q10 22.8 10 22 L10 13.6 L7 13.6 Z" />
      </g>
      {/* Knife - right */}
      <g fill="#fff">
        <path d="M18 6 Q21.5 7 21.8 12.5 Q21.8 15 19.5 15 L18.8 15 L18.8 22 Q18.8 22.8 18 22.8 Q17.2 22.8 17.2 22 L17.2 6.8 Q17.2 6 18 6 Z" />
      </g>
    </svg>
  );
}
